export const HB = {
    init: () => {
        const hbEl = document.querySelector("header.desktop.homepage");
        const mobileEl = document.querySelector(".homebanner-content-mobile");

        if (!hbEl) return;

        const maxImg = parseInt(hbEl.getAttribute("data-maximg")) || 1;
        const rnum = 1 + Math.floor(Math.random() * maxImg);

        // Home uses its own taller banner set (ratio ~2.74, 3840x1400) so the 700px-high
        // header is not upscaled and cropped like the panoramic /images/cover set (ratio 4.22)
        const folder = "/images/homebanner";
        let season = hbEl.getAttribute("data-season") || "summer";
        // Serve the home banner as WebP (like the rest of the site) instead of the raw JPG.
        // Always serve the 2x crop so the banner stays sharp on every display, including
        // Windows screens at 125% scaling (DPR 1.25) that fell below the old 1.3 threshold.
        const cache = "&format=webp&quality=75&id=5";

        // rmode=crop fills the container exactly; rmode=max left the image shorter than the
        // header, so the browser upscaled it and it looked pixelated
        const crops = {
            xl: `?width=3840&height=1400&rmode=crop${cache}`,
            lg: `?width=3200&height=1400&rmode=crop${cache}`,
            md: `?width=2400&height=1400&rmode=crop${cache}`,
            sm: `?width=1982&height=1600&rmode=crop${cache}`,
            xs: `?width=1536&height=1280&rmode=crop${cache}`,
            xxs: `?width=960&height=1200&rmode=crop${cache}`
        };

        const bg = `${folder}/${season}/bg-${rnum}.jpg`;

        const css = `
            header.desktop.homepage,
            .homebanner-content-mobile {
                background-image: url(${bg}${crops.xl});
            }

            @media (max-width: 1600px) {
                header.desktop.homepage,
                .homebanner-content-mobile {
                    background-image: url(${bg}${crops.lg});
                }
            }

            @media (max-width: 1200px) {
                header.desktop.homepage,
                .homebanner-content-mobile {
                    background-image: url(${bg}${crops.md});
                }
            }

            @media (max-width: 991px) {
                header.desktop.homepage,
                .homebanner-content-mobile {
                    background-image: url(${bg}${crops.sm});
                }
            }

            @media (max-width: 768px) {
                header.desktop.homepage,
                .homebanner-content-mobile {
                    background-image: url(${bg}${crops.xs});
                }
            }

            @media (max-width: 480px) {
                header.desktop.homepage,
                .homebanner-content-mobile {
                    background-image: url(${bg}${crops.xxs});
                }
            }
        `;

        const style = document.createElement("style");
        style.id = "HBcoverStyle";
        style.textContent = css;
        document.head.appendChild(style);
    }
};
